import React, { useEffect } from 'react';
import Input from '../Input';
const Number = (props) => {
    //! Disable number input scroll
    useEffect(() => {
        const handleWheel = (e) => {
            if (e.target.type === 'number') {
                e.target.blur();
            }
        };
        const handleKeyDown = (e) => {
            if (e.target.type === 'number') {
                const key = e.charCode || e.keyCode;
                //! Prevent arrow keys (38 = Up, 40 = Down)
                if (key === 38 || key === 40) {
                    e.preventDefault();
                }
            }
        };
        document.addEventListener('wheel', handleWheel, { passive: false });
        document.addEventListener('mousewheel', handleWheel, { passive: false });
        document.addEventListener('keydown', handleKeyDown);
        //! ✅ Correct cleanup function
        return () => {
            document.removeEventListener('wheel', handleWheel);
            document.removeEventListener('mousewheel', handleWheel);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return (React.createElement(Input, { type: 'number', ...props }));
};
if (process.env.NODE_ENV !== 'production') {
    Number.displayName = 'InputNumber';
}
export default Number;
//# sourceMappingURL=index.js.map